import CRUD from 'src/store/models/helper/CRUD.js'

export class Pattern extends CRUD {
  static entity = 'patterns'

  static fields () {
    return {
      id: this.attr(null),
      school_id: this.attr(null),
      name: this.string(''),
      shortcut: this.string(''),
      begins_at: this.attr(null),
      ends_at: this.attr(null),
      patterns: this.attr([]),
      description: this.string(''),
      created_at: this.attr(null),
      updated_at: this.attr(null),
      meta: this.attr({})
    }
  }
}

export default Pattern
